<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h2 class="nobreak" id="CHAPTER_I">CHAPTER I<br class="calibre4"/>
<span class="fs3">THE RUNAWAY HORSE</span></h2>
</div>
<p class="calibre2">Bunny Brown stood behind a long board
which was laid across two boxes in the front
yard. On the board were some piles of white
stones and little heaps of red pebbles. There
were also clam shells, a few filled with white
sand and others with brown sand.</p>
<p class="calibre2">On one end of the board were some pieces
of paper cut into squares and near them was a
ball of string. On the other end of the board,
balanced on a small box, was a shingle. This
shingle moved up and down like the scales in
a grocery store. In fact, this shingle and the
box were Bunny Brown’s scale. He was
“playing store.”</p>
<p class="calibre2"><span id="Page_2" title="[Pg 2]"></span></p>
<p class="calibre2">“Well, I wonder if anybody is coming to
buy anything at my store to-day,” said Bunny,
as he paced up and down behind the counter.</p>
<p class="calibre2">Just then a little girl, carrying a doll under
one arm, walked up to the shade tree under
which the play store was. She went to the
counter and looked at the piles of sand, pebbles,
and the clam shells. But Bunny Brown
did not seem to think she was a little girl. He
bowed to her and asked:</p>
<p class="calibre2">“What will it be to-day, Mrs. Anderson?”</p>
<p class="calibre2">“Oh, Bunny! You sound just like Mr. Gordon
in the real grocery store!” laughed Sue,
clapping her hands. As she did this her doll
fell down on the grass. “You’re just like Mr.
Gordon!” cried the little girl again.</p>
<p class="calibre2">Bunny Brown frowned, wrinkling his forehead
until it looked like a wash-board from
the laundry.</p>
<p class="calibre2">“Look here!” he exclaimed, coming out
from behind the counter. “I’m not going to
play store if you do that!”</p>
<p class="calibre2">“Do what?” asked Sue, for it was Bunny
Brown’s sister Sue who had come to the store.
Bunny had called her “Mrs. Anderson,” but<span id="Page_3" title="[Pg 3]"></span>
all the same, she was Sue Brown. “What did
I do, Bunny?” asked Sue.</p>
<p class="calibre2">“There you go again!” cried Bunny. “Stop
calling me by my right name! If we’re going
to play store I’m Mr. Gordon and you’re Mrs.
Anderson!”</p>
<p class="calibre2">“Yes, I know, Bunny, but—”</p>
<p class="calibre2">“Oh, will you stop it?” cried the little boy,
dancing up and down in his excitement. “I’m
Mr. Gordon keeping the store!” he explained.</p>
<p class="calibre2">“Yes, I know you are,” admitted Sue. “I
said you sounded just like Mr. Gordon when
mother goes in and he says what will it be to-day,
Mrs. Brown. You sounded just like him,
and—”</p>
<p class="calibre2">“Well, then, you must call me Mr. Gordon!”
insisted Bunny. “Now start over again.”</p>
<p class="calibre2">“Oh, all right, Bun—I mean Mr. Gordon!”
and Sue quickly corrected herself. “Wait a
minute.”</p>
<p class="calibre2">She picked up her doll from the grass and,
imitating as nearly as she could the manner
of a grown woman, walked out of the store.
Of course the store was out of doors, in the
front yard of the Brown home, under the<span id="Page_4" title="[Pg 4]"></span>
trees. But to Bunny the store was very real,
indeed. Bunny could “pretend” much harder
than could Sue, because, possibly, he was a
year older.</p>
<p class="calibre2">Sue—or Mrs. Anderson—having gone out,
turned about to come in again. Bunny was
once more behind the counter, looking at the
clam shells, the piles of pebbles, and the sand,
at his wrapping paper and twine and at the
swaying shingle on a box—his scales.</p>
<p class="calibre2">“Good morning, Mrs. Anderson, what will
it be to-day?” again asked the little boy storekeeper
as he bowed to his sister.</p>
<p class="calibre2">“Oh, good morning, Mr. Gordon,” replied
Sue, and she did not even smile as she gave
her brother the pretend name. This showed
that Sue was now playing the game in real
earnest. “Have you any sugar this morning,
Mr. Gordon?”</p>
<p class="calibre2">“Yes, Mrs. Anderson, I have some nice
fresh sugar that just came in,” Bunny answered,
acting so much like Mr. Gordon, the
real grocer, that Sue nearly smiled at him.
But she remembered just in time and her face
grew serious.</p>
<p class="calibre2"><span id="Page_5" title="[Pg 5]"></span></p>
<p class="calibre2">“Do you wish white sugar or brown, Mrs.
Anderson?” asked Bunny. I can call him that
without getting into trouble, you know.</p>
<p class="calibre2">“I’ll have a pound of white sugar, and two
pounds of brown,” answered Sue, or Mrs.
Anderson.</p>
<p class="calibre2">“Please have a seat while I weigh it for
you,” the little storekeeper went on.</p>
<p class="calibre2">In front of the counter there was a small
box. Pretending that this was a stool, such
as they sometimes have in real stores, Sue sat
down on it.</p>
<p class="calibre2">Then Bunny, taking up a stone for a weight,
put it on one end of the shingle scales. On
the other end of the shingle he piled up some
white sand, and when the shingle balanced,
that was a pound. He put the white sand in
one of the pieces of paper and tied a string
around it.</p>
<p class="calibre2">“There is your white sugar, Mrs. Anderson,”
he said to his sister. Sue took it but
cried:</p>
<p class="calibre2">“Oh, Bunny, there’s a hole in the paper and
all the sand is running out! Look!”</p>
<p class="calibre2">Bunny Brown raised his hands in the air.</p>
<p class="calibre2"><span id="Page_6" title="[Pg 6]"></span></p>
<p class="calibre2">“There you go again!” he cried. “Didn’t
I tell you to call me Mr. Gordon and not
Bunny? And that isn’t sand—it’s sugar! If
you aren’t going to play right—”</p>
<p class="calibre2">“Oh, Bunny—I mean Mr. Gordon—I forgot!”
gasped Sue. “Truly, I did! Come on
and play!” she begged, for Bunny started to
walk out from behind the counter. “I won’t
do it again! Really, I won’t, Bun—I mean
Mr. Gordon! And I don’t care if this san—I
mean if the sugar spills. I have lots of
money and I can buy more,” and she looked
in her pocket where a mass of green leaves
from the lilac bush took the place of money.</p>
<p class="calibre2">“Well, all right,” said Bunny slowly, after
a moment. “But if you forget again I’m not
going to play!”</p>
<p class="calibre2">“I won’t forget,” promised Sue.</p>
<p class="calibre2">She placed the paper of sand-sugar down on
the counter in front of her, brushed some of
the grains off her doll’s dress and said:</p>
<p class="calibre2">“Now I’ll have some brown sugar, Mr.
Gordon.”</p>
<p class="calibre2">“Yes, Mrs. Anderson,” said Bunny. “This
brown sugar is very sweet. Just taste it!”</p>
<p class="calibre2"><span id="Page_7" title="[Pg 7]"></span></p>
<p class="calibre2">He held some of the brown sand out to his
sister. She looked at him in a funny way, and
Bunny cried:</p>
<p class="calibre2">“Go on—taste it!”</p>
<p class="calibre2">Thereupon Sue wet the end of her finger
and dipped it in the sand Bunny held out to
her on the end of a little board. Then Sue
put the sand on the tip of her tongue.</p>
<p class="calibre2">“Burr-r-r! Ugh! Oh, yes, it is very sweet
sugar!” she exclaimed, making a funny face
as she spluttered until the sand was out of her
mouth. “I think I’ll have two pounds of that,
Mr. Gordon.”</p>
<p class="calibre2">Bunny never smiled at the funny face his
sister made when she tasted the sand. When
Bunny played anything he was very much in
earnest, as I have told you.</p>
<p class="calibre2">He put another stone on the weight end of
the shingle scale. He then dipped out twice
as much brown sand as he had of the white
and wrapped this up in a paper which he tied
with a piece of string.</p>
<p class="calibre2">“There is the brown sugar, Mrs. Anderson,”
he said. “And now what else will there
be to-day?”</p>
<p class="calibre2"><span id="Page_8" title="[Pg 8]"></span></p>
<p class="calibre2">Bunny Brown acted so much like Sam Gordon,
the real grocer, and even imitated his
talk and manners so well, that Sue felt like
laughing. But she knew that if she did so her
brother would not play any more, so she kept
as straight a face as she could and said:</p>
<p class="calibre2">“Have you any fresh eggs, Mr. Gordon?”</p>
<p class="calibre2">“Oh, yes, Mrs. Anderson, some very fresh
ones. They were picked just this morning!”</p>
<p class="calibre2">“Oh, Bunny Brown, you don’t pick eggs!
They grow in the chicken coop!” giggled Sue.
And Bunny, knowing that he had made a mistake,
did not find fault this time with Sue for
calling him Bunny instead of Mr. Gordon.</p>
<p class="calibre2">“I mean,” corrected the little boy, “that the
eggs were laid fresh this morning.”</p>
<p class="calibre2">“Then I’ll take a dozen,” said Sue, getting
her face straight again.</p>
<p class="calibre2">Bunny picked up twelve of the larger white
pebbles and put these in an old cracker box,
of which he had several under the counter.</p>
<p class="calibre2">“Be careful not to break the eggs, Mrs. Anderson,”
he said, handing Sue the box. “Is
there anything else?”</p>
<p class="calibre2">“I think that’s all,” said Sue gravely, as she<span id="Page_9" title="[Pg 9]"></span>
had heard her mother say. “How much is
it?”</p>
<p class="calibre2">Bunny pretended to be adding up the cost
of the pound of white sand-sugar, the two
pounds of the brown sand-sugar, and the price
of the dozen white-pebble-eggs.</p>
<p class="calibre2">“That’s a dollar and fifty-seven cents,” he
finally said.</p>
<p class="calibre2">Sue took out a large green leaf and two
smaller ones. And Bunny gave her back, in
change, two red petals from a rose.</p>
<p class="calibre2">“Come again, Mrs. Anderson,” he called as
Sue, tucking her doll under one arm and her
packages under the other, started away from
the play store. She walked across the grass
and down toward the bushes that grew as a
sort of hedge in front of the house.</p>
<p class="calibre2">As she neared the gate, Sue saw something
which caused her to cry out:</p>
<p class="calibre2">“Oh, look, Bunny! Look! Quick!”</p>
<p class="calibre2">“Say, didn’t I tell you I’m Mr. Gordon, the
grocer, and you mustn’t call me Bunny?”
cried the little boy. “Now I’m not going to
play store any more!”</p>
<p class="calibre2">“I don’t want to play store!” exclaimed<span id="Page_10" title="[Pg 10]"></span>
Sue, who was much excited. “Look, Bunny!
It’s a runaway horse and he’s coming right
this way!”</p>
<p class="calibre2">This made Bunny forget all about being a
grocer. Out from behind the counter he ran
to join his sister near the gate. He saw, coming
down the street, a galloping horse on the
back of which was a man who either had lost
the bridle or who did not know how to manage
the animal.</p>
<p class="calibre2">“Oh, Sue, it is a runaway!” gasped Bunny,
and for the first time since the store game had
begun he called his sister by her right name.
“I wonder whose it is?”</p>
<p class="calibre2">“I guess it’s that man’s,” said Sue. “Look!
He’s coming right for us! I’m going to run!”</p>
<p class="calibre2">“He won’t come here!” said Bunny. “He
can’t jump over the bushes, Sue.”</p>
<p class="calibre2">The man on the back of the horse seemed
either frightened or excited. He was now
leaning forward, his arms around the neck of
the animal, and he cried:</p>
<p class="calibre2">“Avast there! Belay! Drop your anchor!
Pull up at the dock! I want to go ashore!”</p>
<p class="calibre2"><span id="Page_11" title="[Pg 11]"></span></p>
<p class="calibre2">Bunny thought this was a funny way to talk
to a horse.</p>
<p class="calibre2">“He should say ‘whoa’ or ‘back’ to him,”
thought Bunny. “He’s talking just like
Bunker Blue or one of the sailors down at
daddy’s dock.”</p>
<p class="calibre2">But neither Bunny Brown nor his sister Sue
had time to think much more or do much
more. All of a sudden the horse came up on
the sidewalk near the Brown gate. Then, just
outside the hedge of bushes, the horse came to
a sudden stop.</p>
<p class="calibre2">Off his back shot the man, up into the air,
over the bushes in a curve, and then he fell to
the ground with a groan.</p>
<p class="calibre2">“Oh! Oh!” cried Bunny’s sister Sue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?c6831d76